"use client";

import React from "react";
import { Navbar, Footer } from "@/components/layout/NavbarFooter";
import { useLanguage } from "@/context/LanguageContext";

export default function CookiesPolicy() {
  const { t } = useLanguage();

  return (
    <>
      <Navbar />
      <main className="min-h-screen bg-[#040d21] pt-32 pb-20 selection:bg-[#00f3ff] selection:text-[#040d21]">
        {/* Decorative elements */}
        <div className="absolute top-0 left-1/3 w-[500px] h-[500px] bg-[#0066ff]/5 rounded-full blur-[120px] pointer-events-none" />
        <div className="absolute bottom-0 right-1/3 w-[400px] h-[400px] bg-[#00f3ff]/5 rounded-full blur-[100px] pointer-events-none" />

        <div className="max-w-5xl mx-auto px-6 relative z-10">
          <div className="bg-[#0a192f]/60 backdrop-blur-2xl rounded-[3rem] border border-[#00f3ff]/10 p-8 md:p-16 shadow-[0_20px_50px_rgba(0,0,0,0.5)] group hover:border-[#00f3ff]/20 transition-all duration-500">
            <h1 className="text-4xl md:text-6xl font-black text-white mb-12 tracking-tighter leading-tight">
              Chính sách{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00f3ff] to-[#0066ff] drop-shadow-[0_0_15px_rgba(0,243,255,0.3)]">
                Cookies
              </span>
            </h1>

            <div className="space-y-10 text-slate-300 font-medium leading-relaxed">
              <section className="space-y-4">
                <p className="text-lg">
                  Chính sách Cookies này giải thích cách Công ty Cổ phần Đầu tư AHV Holding
                  (sau đây gọi tắt là &quot;chúng tôi&quot;) sử dụng cookies và các công nghệ
                  theo dõi tương tự trên trang web và các nền tảng số của chúng tôi. Bằng việc
                  tiếp tục sử dụng trang web, bạn đồng ý với việc sử dụng cookies như được
                  mô tả trong chính sách này.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white flex items-center gap-3">
                  <span className="w-2 h-8 bg-gradient-to-b from-[#00f3ff] to-[#0066ff] rounded-full" />
                  Cookies là gì?
                </h2>
                <p>
                  Cookies là các tệp văn bản nhỏ được lưu trữ trên thiết bị của bạn (máy tính,
                  điện thoại di động, máy tính bảng) khi bạn truy cập trang web. Cookies giúp
                  trang web ghi nhớ thông tin về lượt truy cập của bạn, chẳng hạn như ngôn ngữ
                  ưa thích và các tùy chọn khác, giúp cho lần truy cập tiếp theo dễ dàng hơn
                  và trang web trở nên hữu ích hơn cho bạn.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white flex items-center gap-3">
                  <span className="w-2 h-8 bg-gradient-to-b from-[#00f3ff] to-[#0066ff] rounded-full" />
                  Các loại Cookies chúng tôi sử dụng
                </h2>

                <div className="space-y-6">
                  <div className="p-6 bg-[#040d21]/40 border border-[#00f3ff]/10 rounded-[2rem]">
                    <h3 className="text-lg font-bold text-[#00f3ff] mb-2">1. Cookies Cần thiết</h3>
                    <p>
                      Đây là các cookies thiết yếu để trang web hoạt động đúng cách. Chúng cho phép
                      bạn điều hướng trang web và sử dụng các tính năng cốt lõi như truy cập vào
                      các khu vực bảo mật. Không có các cookies này, trang web không thể hoạt động
                      bình thường.
                    </p>
                  </div>

                  <div className="p-6 bg-[#040d21]/40 border border-[#00f3ff]/10 rounded-[2rem]">
                    <h3 className="text-lg font-bold text-[#00f3ff] mb-2">2. Cookies Phân tích / Hiệu suất</h3>
                    <p>
                      Các cookies này cho phép chúng tôi nhận ra và đếm số lượng khách truy cập, đồng
                      thời xem cách khách truy cập di chuyển trên trang web. Điều này giúp chúng tôi
                      cải thiện cách thức hoạt động của trang web, ví dụ như đảm bảo người dùng tìm
                      thấy những gì họ cần một cách dễ dàng.
                    </p>
                  </div>

                  <div className="p-6 bg-[#040d21]/40 border border-[#00f3ff]/10 rounded-[2rem]">
                    <h3 className="text-lg font-bold text-[#00f3ff] mb-2">3. Cookies Chức năng</h3>
                    <p>
                      Các cookies này được sử dụng để nhận ra bạn khi bạn quay lại trang web. Điều
                      này cho phép chúng tôi cá nhân hóa nội dung, ghi nhớ các tùy chọn của bạn
                      (ví dụ: lựa chọn ngôn ngữ hoặc khu vực) và cung cấp các tính năng nâng cao,
                      được cá nhân hóa hơn.
                    </p>
                  </div>

                  <div className="p-6 bg-[#040d21]/40 border border-[#00f3ff]/10 rounded-[2rem]">
                    <h3 className="text-lg font-bold text-[#00f3ff] mb-2">4. Cookies Tiếp thị / Quảng cáo</h3>
                    <p>
                      Các cookies này được sử dụng để theo dõi khách truy cập trên các trang web.
                      Mục đích là hiển thị các quảng cáo có liên quan và hấp dẫn đối với người dùng
                      cá nhân, từ đó có giá trị hơn cho các nhà xuất bản và nhà quảng cáo bên thứ ba.
                    </p>
                  </div>
                </div>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white flex items-center gap-3">
                  <span className="w-2 h-8 bg-gradient-to-b from-[#00f3ff] to-[#0066ff] rounded-full" />
                  Cookies của Bên Thứ ba
                </h2>
                <p>
                  Ngoài cookies của riêng chúng tôi, chúng tôi cũng sử dụng các cookies từ
                  bên thứ ba để báo cáo thống kê sử dụng trang web và cung cấp quảng cáo
                  trên và thông qua trang web. Các dịch vụ bên thứ ba bao gồm:
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6">
                  {[
                    { name: "Google Analytics", url: "https://policies.google.com/technologies/cookies" },
                    { name: "Facebook Pixel", url: "https://www.facebook.com/policies/cookies/" },
                    { name: "Google Tag Manager", url: "https://policies.google.com/privacy" },
                  ].map((link, i) => (
                    <a
                      key={i}
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center justify-between p-4 bg-[#040d21]/40 border border-[#00f3ff]/10 rounded-2xl hover:border-[#00f3ff]/40 hover:bg-[#00f3ff]/5 transition-all group/link"
                    >
                      <span className="font-bold text-white group-hover/link:text-[#00f3ff] transition-colors">{link.name}</span>
                      <span className="material-symbols-outlined text-sm text-[#00f3ff] opacity-0 group-hover/link:opacity-100 transition-all transform translate-x-[-10px] group-hover/link:translate-x-0">
                        open_in_new
                      </span>
                    </a>
                  ))}
                </div>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white flex items-center gap-3">
                  <span className="w-2 h-8 bg-gradient-to-b from-[#00f3ff] to-[#0066ff] rounded-full" />
                  Quản lý Cookies
                </h2>
                <p>
                  Bạn có thể kiểm soát và/hoặc xóa cookies theo ý muốn. Hầu hết các trình
                  duyệt web đều cho phép bạn quản lý cài đặt cookies thông qua tùy chọn cài
                  đặt của trình duyệt. Dưới đây là hướng dẫn quản lý cookies trên các trình
                  duyệt phổ biến:
                </p>
                <ul className="list-none space-y-3 pl-4">
                  {[
                    "Google Chrome: Cài đặt → Quyền riêng tư và bảo mật → Cookies",
                    "Mozilla Firefox: Tùy chọn → Quyền riêng tư & Bảo mật → Cookies",
                    "Safari: Tùy chọn → Quyền riêng tư → Cookies và dữ liệu trang web",
                    "Microsoft Edge: Cài đặt → Cookies và quyền truy cập trang web",
                  ].map((item, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#00f3ff] shadow-[0_0_8px_#00f3ff] flex-shrink-0" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
                <div className="p-6 bg-[#00f3ff]/5 border border-[#00f3ff]/20 rounded-[2rem] italic">
                  Lưu ý: Nếu bạn tắt cookies, một số tính năng của trang web có thể không
                  hoạt động đúng cách hoặc bạn có thể không truy cập được một số phần của
                  trang web.
                </div>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white flex items-center gap-3">
                  <span className="w-2 h-8 bg-gradient-to-b from-[#00f3ff] to-[#0066ff] rounded-full" />
                  Thay đổi Chính sách Cookies
                </h2>
                <p>
                  Chúng tôi có thể cập nhật Chính sách Cookies này theo thời gian để phản ánh
                  các thay đổi trong hoạt động của chúng tôi hoặc vì các lý do pháp lý, quy
                  định khác. Chúng tôi khuyến nghị bạn xem lại chính sách này định kỳ để luôn
                  được cập nhật về cách chúng tôi sử dụng cookies.
                </p>
                <p className="font-bold text-[#00f3ff]">
                  Chính sách Cookies này có hiệu lực từ ngày 03-02-2026
                </p>
              </section>

              <hr className="border-[#00f3ff]/10 my-10" />

              <div className="text-center text-sm text-slate-400">
                <p>
                  Nếu bạn có bất kỳ câu hỏi nào về Chính sách Cookies của chúng tôi,
                  vui lòng liên hệ qua email tại{" "}
                  <a href="mailto:ahvholding.com@gmail.com" className="text-[#00f3ff] hover:underline font-bold">
                    ahvholding.com@gmail.com
                  </a>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
